import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientWarehouseEntity } from './client-warehouse.entity';
import { CompanyWarehouseEntity } from './company-warehouse.entity';
import { ItemLotEntity } from './item-lot.entity';
import { ItemWarehouseEntity } from './item-warehouse.entity';
import { UserWarehouseEntity } from './user-warehouse.entity';

@Index('warehouse_externalId_uindex', ['externalId'], { unique: true })
@Entity('warehouse')
export class WarehouseEntity extends BaseEntity {
	@Column('varchar', { name: 'externalId', nullable: true, length: 64 })
	public externalId!: string | null;

	@Column('varchar', { name: 'name', length: 64 })
	public name!: string;

	@Column('varchar', { name: 'address1', nullable: true, length: 128 })
	public address1!: string | null;

	@Column('varchar', { name: 'address2', nullable: true, length: 128 })
	public address2!: string | null;

	@Column('varchar', { name: 'city', nullable: true, length: 64 })
	public city!: string | null;

	@Column('varchar', { name: 'state', nullable: true, length: 16 })
	public state!: string | null;

	@Column('varchar', { name: 'zip', nullable: true, length: 16 })
	public zip!: string | null;

	@Column('decimal', {
		name: 'latitude',
		precision: 10,
		scale: 8,
		nullable: true,
	})
	public latitude!: number | null;

	@Column('decimal', {
		name: 'longitude',
		precision: 11,
		scale: 8,
		nullable: true,
	})
	public longitude!: number | null;

	@Column('datetime', { name: 'lastImportDate', nullable: true })
	public lastImportDate!: Date | null;

	@OneToMany(
		() => ClientWarehouseEntity,
		(clientWarehouse) => clientWarehouse.fkWarehouse,
	)
	public clientWarehouses!: Array<ClientWarehouseEntity>;

	@OneToMany(
		() => CompanyWarehouseEntity,
		(companyWarehouse) => companyWarehouse.fkWarehouse,
	)
	public companyWarehouses!: Array<CompanyWarehouseEntity>;

	@OneToMany(() => ItemLotEntity, (itemLot) => itemLot.warehouse)
	public itemLots!: Array<ItemLotEntity>;

	@OneToMany(
		() => ItemWarehouseEntity,
		(itemWarehouse) => itemWarehouse.warehouse,
	)
	public itemWarehouses!: Array<ItemWarehouseEntity>;

	@OneToMany(
		() => UserWarehouseEntity,
		(userWarehouse) => userWarehouse.fkWarehouse,
	)
	public userWarehouses!: Array<UserWarehouseEntity>;
}
